{
  "nav": {
    "home": "მთავარი",
    "whatToSee": "სანახაობები",
    "thingsToDo": "აქტივობები",
    "stayAndEat": "სად დავრჩეთ და ვჭამოთ",
    "planYourTrip": "დაგეგმე მოგზაურობა",
    "becomeAMember": "გახდი წევრი",
    "centralMeskheti": "ცენტრალური მესხეთი",
    "borjomiBakuriani": "ბორჯომი – ბაკურიანი",
    "javakheti": "ჯავახეთი",
    "activitiesAndTours": "აქტივობები და ტურები",
    "hikingTrailMap": "ლაშქრობის ბილიკების რუკა",
    "events": "ღონისძიებები",
    "agritourism": "აგროტურიზმი",
    "hotelsResorts": "სასტუმროები და კურორტები",
    "guestHouses": "სასტუმრო სახლები",
    "wineCulinary": "ღვინო და კულინარია",
    "restaurants": "რესტორნები",
    "itineraries": "მარშრუტები და ტურები",
    "brochures": "ბროშურები",
    "menu": "მენიუ",
    "expandSection": "გახსენი {{section}}",
    "collapseSection": "დახურე {{section}}"
  },
  "a11y": {
    "toggleTheme": "გადართე {{mode}} თემაზე",
    "switchLanguage": "ენის შეცვლა",
    "openMenu": "მენიუს გახსნა",
    "closeMenu": "მენიუს დახურვა",
    "closeModal": "დახურვა"
  },
  "theme": {
    "light": "ნათელ",
    "dark": "მუქ"
  },
  "hero": {
    "learnMore": "გაიგე მეტი",
    "infiniteInVariety": "უსასრულო მრავალფეროვნება"
  },
  "home": {
    "heroTitle": "სამცხე – ჯავახეთი",
    "heroSubtitle": "თქვენი გამოცდილება იქნება უსასრულოდ მრავალფეროვანი",
    "overline": "თქვენი გამოცდილება იქნება უსასრულოდ მრავალფეროვანი",
    "planYourTrip": "დაგეგმე მოგზაურობა",
    "playVideo": "სარეკლამო ვიდეოს ჩართვა",
    "discoverCardTitle": "უსასრულო მრავალფეროვნება",
    "discoverCardSubtitle": "აღმოაჩინე სამცხე – ჯავახეთი",
    "learnMore": "გაიგე მეტი",
    "follow": "გამოგვყევი",
    "social_x": "გამოგვყევი X-ზე",
    "social_facebook": "გამოგვყევი Facebook-ზე",
    "social_instagram": "გამოგვყევი Instagram-ზე",
    "social_linkedin": "გამოგვყევი LinkedIn-ზე",
    "adventureTitle": "შენი თავგადასავალი აქ იწყება",
    "adventureSubtitle": "არ იცი საიდან დაიწყო? აი, საუკეთესო გამოცდილებები:",
    "trailsPromoTitle": "გაეცანი რეგიონის ყველა ლაშქრობის ბილიკს",
    "trailsPromoSubtitle": "სამცხე-ჯავახეთი სავსეა სანახავი ადგილებით, ამიტომ მოემზადე ჩვენი ლაშქრობის ბილიკებისთვის!",
    "trailsFindDestination": "იპოვე შენი მიმართულება",
    "trailsCardTitle": "ლაშქრობის ბილიკები",
    "trailsCardText": "მოგზაურობა შესანიშნავი გზაა ახალი ადგილების აღმოსაჩენად, სხვადასხვა კულტურის გასაცნობად და უნიკალური გამოცდილების მისაღებად.",
    "trailsPlayJourney": "ითამაშე და იმოგზაურე",
    "infiniteHeadline": "უსასრულო თავგადასავალი გელოდება",
    "infiniteHeadlineAccent": "სამცხე-ჯავახეთში",
    "infiniteBody": "სამცხე-ჯავახეთი, საქართველოს ერთ-ერთი უმნიშვნელოვანესი ისტორიული და ეთნოგრაფიული რეგიონი, მდიდარია მრავალფეროვნებით: განსხვავებული მიკროკლიმატი, თოვლიანი მთებიდან უხვ ტყეებამდე, სუფთა მდინარეებითა და ტბებით.",
    "infiniteCtaTitle": "უსასრულო თავგადასავალი გელოდება",
    "infiniteCtaSubtitle": "იპოვე აქტივობები სამცხე – ჯავახეთში",
    "appTitle": "იპოვე ლაშქრობის ბილიკები ჩვენს მობილურ აპლიკაციაში",
    "appBody": "HikeSJ — შენი გზამკვლევი სამცხე-ჯავახეთში, საქართველო. აღმოაჩინე ბუნება HikeSJ-თან ერთად!",
    "appStoreTop": "ჩამოტვირთე",
    "appStoreName": "App Store",
    "playStoreName": "Google Play",
    "highlightsTitle": "მთავარი ამბები",
    "highlightsSubtitle": "აი, სიახლეები, რომლებიც შეიძლება დაგაინტერესოს",
    "appComingSoon": "მალე"
  },
  "carousel": {
    "prev": "წინა",
    "next": "შემდეგი"
  },
  "footer": {
    "contactUs": "დაგვიკავშირდით",
    "dmo": "სამცხე-ჯავახეთის DMO",
    "offers": "შეთავაზებები",
    "getInTouch": "კონტაქტი",
    "privacyPolicy": "კონფიდენციალურობის პოლიტიკა",
    "termsOfService": "მომსახურების პირობები",
    "cookiePolicy": "ქუქი-ფაილების პოლიტიკა",
    "news": "სიახლეები",
    "blog": "ბლოგი",
    "aboutDmo": "DMO-ს შესახებ",
    "projects": "პროექტები",
    "reports": "ანგარიშები",
    "offer_meetings": "შეხვედრები",
    "offer_sports": "სპორტი",
    "offer_industry": "ინდუსტრია",
    "offer_travelers": "მოგზაურები",
    "offer_weddings": "ქორწილები"
  },
  "common": {
    "loading": "იტვირთება…",
    "placeholderPage": "ეს გვერდი დროებითია — კონტენტი მოგვიანებით დაემატება."
  },
  "map": {
    "homeHeading": "აღმოაჩინე სამცხე-ჯავახეთის მრავალფეროვნება",
    "homeIntro": "დაათვალიერე სანახაობები სამცხე-ჯავახეთში.",
    "all": "ყველა",
    "viewDetails": "დეტალები",
    "noResults": "ამ ფილტრით ადგილები ჯერ არ მოიძებნა."
  },
  "activities": {
    "hubTitle": "აქტივობები და ტურები",
    "hubSubtitle": "იპოვე შენი თავგადასავალი სამცხე-ჯავახეთში",
    "agritourismTitle": "აგროტურიზმი",
    "agritourismSubtitle": "სოფლის სტუმრობა და გამოცდილება",
    "findMore": "გაიგე მეტი",
    "learnMore": "გაიგე მეტი",
    "website": "ვებსაიტი",
    "phone": "ტელეფონი",
    "email": "ელფოსტა",
    "empty": "აქ ჯერ არაფერია გამოქვეყნებული."
  },
  "trails": {
    "title": "საფეხმავლო ბილიკების რუკა",
    "subtitle": "დაათვალიერე სამცხე-ჯავახეთის ბილიკები",
    "routeLength": "მარშრუტის სიგრძე",
    "elevation": "სიმაღლე",
    "routeType": "მარშრუტის ტიპი",
    "complexity": "სირთულე",
    "address": "მისამართი",
    "details": "დეტალები",
    "routeDescription": "მარშრუტის აღწერა",
    "downloadGpx": "GPX-ის ჩამოტვირთვა",
    "km": "კმ",
    "empty": "ბილიკები ჯერ არ გამოქვეყნებულა.",
    "allDifficulties": "ყველა სირთულე",
    "allRouteTypes": "ყველა ტიპი",
    "difficulty_easy": "მარტივი",
    "difficulty_medium": "საშუალო",
    "difficulty_hard": "რთული",
    "routeType_one_way": "ცალმხრივი",
    "routeType_connecting": "დამაკავშირებელი",
    "routeType_loop": "წრიული"
  },
  "events": {
    "title": "ღონისძიებები",
    "subtitle": "რა ხდება სამცხე-ჯავახეთში",
    "view_list": "სია",
    "view_month": "თვე",
    "details": "დეტალები",
    "when": "როდის",
    "venue": "ადგილი",
    "organizer": "ორგანიზატორი",
    "price": "ფასი",
    "category": "კატეგორია",
    "addToCalendar": "კალენდარში დამატება",
    "venueWebsite": "ვებგვერდი",
    "empty": "მომავალი ღონისძიებები ჯერ არ არის."
  },
  "accommodations": {
    "subtitle": "სად დავრჩეთ და ვჭამოთ სამცხე-ჯავახეთში",
    "findMore": "გაიგე მეტი",
    "address": "მისამართი",
    "website": "ვებგვერდი",
    "empty": "აქ ჯერ არაფერია გამოქვეყნებული.",
    "hotelsResorts": "სასტუმროები და კურორტები",
    "guestHouses": "სასტუმრო სახლები",
    "wineCulinary": "ღვინო და კულინარია",
    "restaurants": "რესტორნები"
  },
  "whatToSee": {
    "title": "სანახაობები",
    "subtitle": "სამი რეგიონი, უსასრულო მრავალფეროვნება",
    "introHeading": "აღმოაჩინე რეგიონები",
    "introText": "სამცხე-ჯავახეთი მოიცავს სამ განსხვავებულ რეგიონს. გადაატარეთ მაუსი რუკაზე ან ბარათზე.",
    "findMore": "გაიგე მეტი",
    "discoverRegion": "აღმოაჩინე {{region}}"
  },
  "attraction": {
    "share": "გააზიარე გამოცდილება",
    "planTrip": "დაგეგმე მოგზაურობა",
    "tips": "რჩევები"
  },
  "posts": {
    "learnMore": "გაიგე მეტი",
    "empty": "აქ ჯერ არაფერია გამოქვეყნებული.",
    "news": "სიახლეები",
    "writtenBy": "ავტორი:",
    "newsTitle": "სიახლეები",
    "newsHeading": "მთავარი ამბები",
    "blogTitle": "ბლოგი",
    "blogHeadingAccent": "ინსაითები",
    "blogHeading": "რომელიც აღვივებს ცნობისმოყვარეობას"
  },
  "projects": {
    "title": "პროექტები",
    "subtitle": "რას აშენებს DMO სამცხე-ჯავახეთში",
    "open": "პროექტის ნახვა",
    "empty": "პროექტები ჯერ არ გამოქვეყნებულა."
  },
  "reports": {
    "title": "ანგარიშები",
    "subtitle": "DMO-ს პუბლიკაციები და სტატისტიკა",
    "open": "ანგარიშის გახსნა",
    "empty": "ანგარიშები ჯერ არ გამოქვეყნებულა."
  },
  "brochures": {
    "title": "ბროშურები",
    "subtitle": "ჩამოტვირთე გზამკვლევები სამცხე-ჯავახეთზე",
    "open": "ბროშურის გახსნა",
    "empty": "ბროშურები ჯერ არ გამოქვეყნებულა."
  },
  "pdf": {
    "openInNewTab": "ახალ ჩანართში გახსნა"
  },
  "discover": {
    "hubTitle": "აღმოაჩინე სამცხე – ჯავახეთი",
    "hubSubtitle": "უსასრულო მრავალფეროვნება",
    "findMore": "გაიგე მეტი"
  },
  "offers": {
    "comingSoon": "მალე",
    "comingSoonSubtitle": "ეს ჯერ არ არის მზად, მაგრამ სხვა რამის ნახვა შეგიძლია."
  },
  "itineraries": {
    "title": "მარშრუტები და ტურები",
    "subtitle": "შემოთავაზებული მარშრუტები სამცხე-ჯავახეთში",
    "findMore": "გაიგე მეტი",
    "stops": "გაჩერებები",
    "days_one": "{{count}} დღე",
    "days_other": "{{count}} დღე",
    "empty": "მარშრუტები ჯერ არ გამოქვეყნებულა."
  },
  "forms": {
    "whoWeAre": "ვინ ვართ ჩვენ",
    "whoWeAreBody": "სამცხე-ჯავახეთის დესტინაციის მართვის ორგანიზაცია დაფუძნდა 2019 წელს რეგიონის ექვსივე მუნიციპალიტეტის მიერ, საქართველოს ტურიზმის ნაციონალური ადმინისტრაციისა და USAID Zrda-ს ინიციატივითა და მხარდაჭერით.",
    "name": "სახელი",
    "namePlaceholder": "შეიყვანე სახელი",
    "email": "ელფოსტა",
    "phone": "ტელეფონი",
    "message": "შეტყობინება",
    "messagePlaceholder": "დაწერე შეტყობინება",
    "sendMessage": "შეტყობინების გაგზავნა",
    "sending": "იგზავნება…",
    "close": "დახურვა",
    "required": "ეს ველი სავალდებულოა.",
    "rateLimited": "ძალიან ბევრი მცდელობა. გთხოვთ, დაელოდოთ წუთს და სცადოთ ხელახლა.",
    "genericError": "რაღაც შეიშალა. გთხოვთ, სცადოთ ხელახლა.",
    "contactSentTitle": "შეტყობინება გაიგზავნა",
    "contactSentBody": "გმადლობთ — მალე დაგიკავშირდებით.",
    "membershipTitle": "წევრის რეგისტრაციის ფორმა",
    "organizationName": "ორგანიზაციის/ბიზნესის დასახელება",
    "representative": "ორგანიზაციის წარმომადგენელი (სახელი/გვარი)",
    "first": "სახელი",
    "last": "გვარი",
    "position": "თანამდებობა",
    "websiteLink": "ვებგვერდის ლინკი",
    "address": "ორგანიზაციის მისამართი",
    "street": "ქუჩის მისამართი",
    "city": "ქალაქი",
    "country": "ქვეყანა",
    "selectPackage": "აირჩიე შესაბამისი წევრობის პაკეტი",
    "package_big_business": "მსხვილი ბიზნესი",
    "package_small_medium_business": "მცირე და საშუალო ბიზნესი",
    "package_individual_member": "ინდივიდუალური წევრი",
    "package_ngo": "არასამთავრობო ორგანიზაცია",
    "secondRepresentative": "ორგანიზაციის მეორე წარმომადგენელი",
    "registerAsMember": "დარეგისტრირდი წევრად",
    "membershipSentTitle": "განაცხადი მიღებულია",
    "membershipSentBody": "გმადლობთ — ჩვენი გუნდი განიხილავს განაცხადს და დაგიკავშირდებით."
  },
  "search": {
    "title": "ძიება",
    "label": "ძიება საიტზე",
    "placeholder": "მოძებნე ადგილები, ბილიკები, ღონისძიებები…",
    "prompt": "დაიწყე წერა, რომ მოძებნო სანახაობები, აქტივობები, ბილიკები, ღონისძიებები, სასტუმროები და სიახლეები.",
    "tooShort": "შეიყვანე მინიმუმ {{count}} სიმბოლო.",
    "empty": "„{{query}}“-ზე ვერაფერი მოიძებნა. სცადე უფრო მოკლე ან სხვა სიტყვა.",
    "count_one": "{{count}} შედეგი",
    "count_other": "{{count}} შედეგი",
    "groups": {
      "attractions": "სანახაობები",
      "activities": "აქტივობები და ტურები",
      "trails": "საფეხმავლო ბილიკები",
      "events": "ღონისძიებები",
      "accommodations": "სად დავრჩეთ და ვჭამოთ",
      "posts": "სიახლეები და ბლოგი"
    }
  },
  "cookies": {
    "title": "ქუქი-ფაილების თანხმობა",
    "body": "ვიყენებთ ანალიტიკის ქუქი-ფაილებს იმის გასაგებად, როგორ სარგებლობენ საიტით. ისინი არჩევითია — საიტი ორივე შემთხვევაში ერთნაირად მუშაობს.",
    "accept": "დათანხმება",
    "decline": "უარყოფა",
    "policyLink": "წაიკითხე ქუქი-ფაილების პოლიტიკა",
    "manage": "ქუქი-ფაილების პარამეტრები"
  }
}
